import { type ReactNode } from 'react';
import classNames from 'classnames';
import styles from './StatusBanner.module.scss';

export type StatusBannerKind = 'success' | 'error' | 'info';

interface StatusBannerProps {
  kind: StatusBannerKind;
  message: ReactNode;
  sublabel?: ReactNode;
  dismissLabel: string;
  onDismiss: () => void;
}

const StatusBanner = ({
  kind,
  message,
  sublabel,
  dismissLabel,
  onDismiss,
}: StatusBannerProps) => {
  return (
    <div
      className={classNames(styles.banner, styles[`banner_${kind}`])}
      role={kind === 'error' ? 'alert' : 'status'}
    >
      <span>{message}</span>
      {sublabel && <span className={styles.sublabel}>{sublabel}</span>}
      <button
        type="button"
        className={styles.dismiss}
        onClick={onDismiss}
        aria-label={dismissLabel}
      >
        ×
      </button>
    </div>
  );
};

export default StatusBanner;
